import { render, staticRenderFns } from "./CargaDescarga.vue?vue&type=template&id=693da7cb"
import script from "./CargaDescarga.vue?vue&type=script&lang=js"
export * from "./CargaDescarga.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports